import { render, staticRenderFns } from "./GoogleForms.vue?vue&type=template&id=34573e48&scoped=true&"
import script from "./GoogleForms.vue?vue&type=script&lang=js&"
export * from "./GoogleForms.vue?vue&type=script&lang=js&"
import style0 from "./GoogleForms.vue?vue&type=style&index=0&id=34573e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34573e48",
  null
  
)

export default component.exports